import * as React from 'react';
import { ReselectApolloStateContext } from 'containers/ApolloAppProvider';

export default function useAppState() {
  return React.useContext(ReselectApolloStateContext);
}
